import { DEFAULT_FEATURE_FLAGS, type FeatureFlags } from "@compass/shared/schema/featureFlags";
import { trpc } from "lib/trpc";

/**
 * Runtime feature flags (PRTL-1353). Returns the schema defaults (everything
 * off) while loading or on error, so gated UI fails closed. Refetches on
 * window focus, so an admin flip reaches open tabs within ~a minute.
 */
export function useFeatureFlags(): FeatureFlags {
    const { data } = trpc.config.flags.useQuery(undefined, {
        staleTime: 60_000,
        refetchOnWindowFocus: true,
    });
    return data ?? DEFAULT_FEATURE_FLAGS;
}
